import { render } from "./Pauze.vue?vue&type=template&id=335eb3d0&scoped=true"
import script from "./Pauze.vue?vue&type=script&lang=js"
export * from "./Pauze.vue?vue&type=script&lang=js"

import "./Pauze.vue?vue&type=style&index=0&id=335eb3d0&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335eb3d0"]])

export default __exports__